<template>
    <div @change="method1" >
  <template>
  <Body
          ref="radio"
          class="Body 2"
        >
          Grouping interval
        </Body>
  <v-row align="center">
    <v-col cols="3">
        <v-text-field
          v-model="day"
          type="number"
          label="Day"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="hours"
          type="number"
          required
          label="Hours"
        ></v-text-field>
      </v-col>
       <v-col cols="3">
        <v-text-field
          v-model="minutes"
          type="number"
          label="Minutes"
          required
        ></v-text-field>
      </v-col>
       <v-col cols="3">
        <v-text-field
          v-model="seconds"
          type="number"
          label="Seconds"
          required
        ></v-text-field>
      </v-col>
  </v-row>
  </template>
</div>
</template>

<script>
export default {
    name:'grouping_interval',
    components:{

    },
    data(){
       return {
         type: 'number',
         day:null,
         hours:null,
         minutes:null,
         seconds:null,
         totalframe:null,
       }
    },
    beforeMount(){
let day = sessionStorage.getItem("day") || 0
let hours =  sessionStorage.getItem('hours')|| 0
let minutes = sessionStorage.getItem('minutes')|| 0
let seconds = sessionStorage.getItem('seconds')|| 0
console.log("before mounting in grouping interval",day,hours,minutes,seconds);


this.day = day || 0;
this.hours = hours || 0;
this.minutes = minutes || 0;
this.seconds = seconds || 0;
    },
     methods:{
       method1(){
           console.log("checking incoming",this.day,this.hours,this.minutes,this.seconds,)
          //  sessionStorage.setItem("day",this.day);
          //  sessionStorage.setItem("hours",this.hours);
          //  sessionStorage.setItem("minutes",this.minutes);
          //  sessionStorage.setItem("seconds",this.seconds);

         this.totalframe = parseInt(this.day)*3600*24 + parseInt(this.hours)*3600 +
         parseInt (this.minutes)*60 + parseInt(this.seconds);
         console.log('checking grouping interval',this.totalframe)
         this.$emit('grouping_interval',this.totalframe, typeof(this.totalframe));     
      }


     }
     
}
</script>